import React, { useState, useEffect, useContext } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ImageComponent from 'atoms/Image';
import { ReactSVG } from 'react-svg';
import {
  getPrice,
  getTernaryValue,
  isMobileDevice,
  getMainImagePath,
  getBackgroundImageSrc,
  getAndCheck,
  getValueOrDefaultObject,
  getValueOrDefaultAlternativeObject,
} from 'common/utilities/utils';
import {
  checkCategoryAvailability,
  checkIteminCart,
  getCategoryUrl,
  getDynamicMenuAlertType,
} from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import { useSelector } from 'react-redux';
import { computeSurgePrice } from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { MENU_PLP_CONSTANT } from 'organisms/MenusPLP/AU/MenuPLPConstants/MenuPLPConstants';
import { RESIZE, MENU_DRINKS, DYNAMIC_MENU_CONSTANTS ,IMAGE_SIZE_CONSTANTS} from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { UserOrderContext } from 'context/context';

/**
 * PLP Menu Component
 */

export const getCardTypeNameForSmall = (allowClickOnProductCard, discount, specials, exclusive, timer) => {
  if (allowClickOnProductCard && (discount || specials || exclusive || timer)) {
    return 'small-menu-product-card small-menu-product-card-long product-card-active';
  } else if (allowClickOnProductCard && !(discount || specials || exclusive || timer)) {
    return 'small-menu-product-card product-card-active';
  } else if (!allowClickOnProductCard && (discount || specials || exclusive || timer)) {
    return 'small-menu-product-card small-menu-product-card-long';
  } else {
    return 'small-menu-product-card';
  }
};

export const getCardTypeName = (
  isMobile,
  allowClickOnProductCard,
  discount,
  specials,
  exclusive,
  timer,
  isExcluded,
) => {
  const additionalClass = isExcluded ? ' product-card-deactive' : '';
  let returnClass = '';
  if (isMobile) {
    returnClass = getCardTypeNameForSmall(allowClickOnProductCard, discount, specials, exclusive, timer);
  } else {
    returnClass = allowClickOnProductCard ? 'medium-menu-product-card product-card-active' : 'medium-menu-product-card';
  }
  return returnClass + additionalClass;
};
export const getProductImageClassName = isMobile => {
  if (isMobile) {
    return 'small-menu-product-image';
  } else {
    return 'medium-menu-product-image';
  }
};

export const getPriceAndKJInfo = (localized, priceMethod, kjInfoMethod, isMobile, className) => {
  return (
    <>
      <div className={className}>
        {localized && priceMethod()}
        {localized && kjInfoMethod(isMobile)}
      </div>
    </>
  );
};
export const getPriceAndKJInfoForCatering = (
  localized,
  categoryUrl,
  priceMethod,
  kjServesInfoMethod,
  isMobile,
  className,
  servesTemplate,
) => {
  return (
    <>
      <div className={className}>
        <>
          {!categoryUrl?.includes(MENU_DRINKS) && kjServesInfoMethod(isMobile)}
          {localized && priceMethod()}
        </>
      </div>
      {!localized && getTernaryValue(categoryUrl?.includes(MENU_DRINKS), <></>, servesTemplate())}
    </>
  );
};
export const getMenuProductHeader = (isMobile, discount, specials, exclusive, timer, newitem, topseller) => {
  if (isMobile) {
    return discount || specials || exclusive || timer || newitem || topseller
      ? 'small-menu-product-header-shift'
      : 'small-menu-product-header';
  } else {
    return 'medium-menu-product-header';
  }
};

const getImageSize = (RECOMMENDED_ITEM, isMobileSize) => {
  const { ITEM_IMAGE_HEIGHT_MOBILE, ITEM_IMAGE_WIDTH_MOBILE, ITEM_IMAGE_HEIGHT_DESKTOP, ITEM_IMAGE_WIDTH_DESKTOP } =
    RECOMMENDED_ITEM;
  if (isMobileSize) {
    return { height: ITEM_IMAGE_HEIGHT_MOBILE, width: ITEM_IMAGE_WIDTH_MOBILE };
  } else {
    return { height: ITEM_IMAGE_HEIGHT_DESKTOP, width: ITEM_IMAGE_WIDTH_DESKTOP };
  }
};

export const productUnavailableText = unavailableProduct => {
  return (
    <div className='unavailable-container'>
      <img src={unavailableProduct} className='unavailable-icon' alt='product-unavaliable' />
      <div className='unavailable-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.PRODUCT_UNAVAILABLE)}</div>
    </div>
  );
};
export function PlpMenuCardViewComponent(props) {
  const {
    allowClickOnProductCard,
    discount,
    specials,
    exclusive,
    timer,
    cardId,
    customizable,
    tenantData,
    imageName,
    onCardClickHandler,
    categoryId,
    dName: dname,
    availability = [],
    newitem,
    topseller,
    getSpecificRibbonBanner,
    userParams,
    item,
    productContent,
    checkForBasePriceInMenu,
    baseprice,
    cardCat,
    displayPrice,
    getPriceClassName,
    serves,
    prodURL = '',
    showCateringflag = false,
    storeTimeZone,
    plpbackgroundImageSrc,
    recommImageSizeFlag = false,
  } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [imageContainerSize, setImageContainerSize] = useState(0);
  const { localized } = getValueOrDefaultObject(userParams);
  const { Product_Card_Icon, ribbonRedOutlined, Error: unavailableProduct } = IMAGE_PATH;
  const isExcluded = getValueOrDefaultAlternativeObject(item?.isExcluded, item?.isNotAvailable);
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const { timeBasedCetegory } = userOrderState;
  const flatRes = useSelector(({ menuReducer: { flatResponse } }) => flatResponse);
  const { RECOMMENDED_ITEM } = IMAGE_SIZE_CONSTANTS;

  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  useEffect(() => {
    windowResized();
    // We only care about the first loaded viewport and not subsequent resizes when calculating imageSize
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const windowResized = () => {
    let isMobileSize = isMobileDevice(window.innerWidth);
    const imageSize = getImageSize(RECOMMENDED_ITEM, isMobileSize);
    setImageContainerSize(imageSize);
    setIsMobile(isMobileSize);
  };

  const priceMethod = () => {
    const newAvailability = computeSurgePrice(availability, storeTimeZone);
    return (
      <div className='medium-menu-product-price'>
        {checkForBasePriceInMenu(baseprice, cardCat) && displayPrice(baseprice, tenantData?.currencyConversionFactor)}
        <span className={getPriceClassName(baseprice, cardCat)}>
          {tenantData?.currencySymbol}
          {getPrice(newAvailability, tenantData?.currencyConversionFactor, storeTimeZone).toFixed(2)}
        </span>
      </div>
    );
  };

  const kjInfoMethod = isMobileSize => {
    return (
      Boolean(productContent?.caloricValue) && (
        <div className={getTernaryValue(isMobileSize, 'small-menu-price-and-KJ dd', 'medium-menu-price-and-KJ dd')}>
          {localized && <div className='Dot'></div>}
          <span>
            {' '}
            {`${productContent.caloricValue} ${tenantData?.kilojoule} `} &nbsp;{' '}
            {`${translateWithI18Next(TRANSLATE_MAPPING_KEY?.SERVES)} ${productContent.serves} `}
          </span>
        </div>
      )
    );
  };
  const kjServesInfoMethod = isMobileSize => {
    return (
      <div className={getTernaryValue(isMobileSize, 'small-menu-price-and-KJ dd', 'medium-menu-price-and-KJ dd')}>
        {productContent?.caloricValue && (
          <span>
            {' '}
            {`${productContent?.caloricValue} ${tenantData?.kilojoule} ${translateWithI18Next(
              TRANSLATE_MAPPING_KEY?.SERVES,
            )} ${productContent.serves} `}
          </span>
        )}
        {serves ? (
          <span>
            {' '}
            <div className='Dot' data-testid='serves-template'></div>
            {servesTemplate()}
          </span>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const servesTemplate = () => {
    return getTernaryValue(
      serves,
      <span className='product-serves'>{` ${translateWithI18Next(
        TRANSLATE_MAPPING_KEY?.SERVES_TEXT,
      )} ${serves}`}</span>,
      <></>,
    );
  };

  const productImageComponent = () => {
    return productContent?.image?.mainImage ? (
      <ImageComponent
        data-testid='product-image'
        className={getProductImageClassName(isMobile)}
        srcFile={getMainImagePath(productContent, imageContainerSize.width, imageContainerSize.height)}
        alt=''
        inactive={isExcluded}
        disabled={isExcluded}
      />
    ) : (
      <></>
    );
  };

  const plpBackgroundStyle = () =>
    getBackgroundImageSrc(plpbackgroundImageSrc, imageContainerSize.width, imageContainerSize.height);

  const priceAndKJInfo = className => {
    return getTernaryValue(
      showCateringflag,
      getPriceAndKJInfoForCatering(
        localized,
        item?.categoryUrl?.[0],
        priceMethod,
        kjServesInfoMethod,
        isMobile,
        'Price-and-KJ-info-catering',
        servesTemplate,
      ),
      getPriceAndKJInfo(localized, priceMethod, kjInfoMethod, isMobile, className),
    );
  };
  const checkItemExpiry = clickObj => {
    const { event, itemId, productInfo, cardId: card_Id } = clickObj;
    event?.stopPropagation();
    event?.preventDefault();
    const categoryUrl = getCategoryUrl(card_Id, flatRes);
    const itemInCart = checkIteminCart(itemId, timeBasedCetegory);
    const categoryExpried = checkCategoryAvailability(
      {
        categoryUrl: categoryUrl,
        itemInCart: itemInCart,
        alertType: getDynamicMenuAlertType(timeBasedCetegory?.timebasedItemInCart, DYNAMIC_MENU_CONSTANTS?.ITEM),
      },
      timeBasedCetegory,
      userOrderStateDispatch,
    );
    if (categoryExpried) {
      return;
    }

    onCardClickHandler(event, itemId, customizable, categoryId, productInfo);
  };
  return (
    <>
      <div
        className={getCardTypeName(isMobile, allowClickOnProductCard, discount, specials, exclusive, timer, isExcluded)}
        data-testid={`click-allow-on-product-${cardId}`}
        id={cardId}
        onClick={event =>
          getAndCheck(allowClickOnProductCard, !isExcluded) &&
          checkItemExpiry({
            event,
            cardId,
            productInfo: {
              productName: dname,
              productImage: imageName,
              productPrice: getPrice(availability[0], tenantData?.currencyConversionFactor),
              prodURL,
              categoryURL: item?.categoryUrl,
            },
          })
        }
        inactive={isExcluded}
        disabled={isExcluded}
      >
        {!isMobile && (
          <div style={plpBackgroundStyle()} className='product-image-parent-container'>
            {productImageComponent()}
          </div>
        )}
        <ReactSVG
          className={getTernaryValue(
            specials,
            'specials-product-ribbon',
            getTernaryValue(exclusive, 'exclusive-product-ribbon', 'discount-product-ribbon'),
          )}
          src={getTernaryValue(
            specials,
            Product_Card_Icon,
            getTernaryValue(discount || exclusive || newitem || topseller, ribbonRedOutlined, ''),
          )}
        />
        <span className={getTernaryValue(specials, 'specials-ribbon-text', 'discount-ribbon-text')}>
          {timer ? (
            <div>
              <svg src={unavailableProduct} className='product-timer' />
              <span className='product-timer-text'>{translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.TIMER)}</span>
            </div>
          ) : (
            getSpecificRibbonBanner(specials, discount, exclusive, newitem, topseller)
          )}
        </span>
        <div
          data-testid='menu-card-content-pdp-nav'
          className='menu-card-content'
          inactive={isExcluded}
          disabled={isExcluded}
        >
          {isMobile ? (
            <>
              <div>
                <div className='description-and-image product-image-parent-container' style={plpBackgroundStyle()}>
                  {isMobile && productImageComponent()}
                </div>
                <div
                  className={getMenuProductHeader(isMobile, discount, specials, exclusive, timer, newitem, topseller)}
                >
                  {dname?.[0].value}
                  <div></div>
                  {getTernaryValue(
                    isExcluded,
                    productUnavailableText(unavailableProduct),
                    priceAndKJInfo('small-price-and-KJ-info'),
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={getMenuProductHeader(isMobile, discount, specials, exclusive, timer, newitem, topseller)}>
                {dname?.[0].value}
              </div>
              {getTernaryValue(
                isExcluded,
                productUnavailableText(unavailableProduct),
                priceAndKJInfo('Price-and-KJ-info'),
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default PlpMenuCardViewComponent;
